import React, { useEffect, useState } from 'react';
import { collection, getDoc, onSnapshot, query, where } from 'firebase/firestore';
import { doc, deleteDoc } from 'firebase/firestore';
import { db, storage } from '../../firebase';
import { ref, deleteObject } from 'firebase/storage';
import { useParams } from 'react-router-dom'; // si usas react-router
import '../../Styles/Documentacion.css';
import { useUserPermissions } from '../../Hooks/GetUserPermissions';
import GetUserData from '../../Hooks/GetUserData';
import { GetHubInfo } from '../../Hooks/UseHubName';

const extractFilePath = (url) => {
  try {
    const urlObj = new URL(url);
    const path = urlObj.pathname; // /v0/b/bucket/o/hubId%2Fdocuments%2Farchivo.pdf
    const prefix = '/o/';
    const startIndex = path.indexOf(prefix);
    if (startIndex === -1) return null;
    let filePath = path.substring(startIndex + prefix.length);
    filePath = decodeURIComponent(filePath);
    return filePath;
  } catch {
    return null;
  }
};





const DocumentList = ({ folderId }) => {
  const [documents, setDocuments] = useState([]);
  const { hubId } = useParams();
  const { permisos } = useUserPermissions();
  const { userData } = GetUserData();
  const hubInfo = GetHubInfo(hubId);

  useEffect(() => {
    if (!folderId) return;

    const q = query(
      collection(db, 'private-hubs', hubId, 'Documentos'),
      where('folderId', '==', folderId)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const docs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      docs.sort((a, b) => a.name.localeCompare(b.name)) 
      setDocuments(docs);
    });

    return () => unsubscribe();
  }, [folderId, hubId]);

  if (!folderId) return null;

  const downloadFile = async (doc) => {
    try {
      if (!hubInfo.useBlocktrace) {
        // === DESCARGA DESDE FIREBASE ===
        console.log("DEBUG - Descargando desde Firebase...");

        const filePath = extractFilePath(doc.url);
        if (!filePath) {
          alert("No se pudo extraer la ruta del archivo");
          return;
        }

        const functionUrl =
          "https://us-central1-lyseis-tools-hub.cloudfunctions.net/downloadFile";
        const bucketName = "lyseis-tools-hub.firebasestorage.app";

        const fullUrl = `${functionUrl}?bucketName=${bucketName}&filePath=${encodeURIComponent(
          filePath
        )}&fileName=${encodeURIComponent(doc.name)}`;

        window.open(fullUrl, "_blank");
      } else {
        // === DESCARGA DESDE BLOCKTRACE (Cloud Function) ===
        console.log("DEBUG - Descargando desde Blocktrace (Cloud Function)...");

        if (!doc.blocktraceInfo?.documentId) {
          alert("No hay documentId para descargar desde Blocktrace");
          return;
        }

        const userOrigin = userData.email;

        try {
          const cloudFunctionUrl = `https://us-central1-lyseis-tools-hub.cloudfunctions.net/blocktraceDownload?documentId=
            ${encodeURIComponent(
              doc.blocktraceInfo.documentId
            )}&userOrigin=${encodeURIComponent(userOrigin)}`;
          const response = await fetch(cloudFunctionUrl, {
            method: "GET",
          });

          if (!response.ok) {
            throw new Error(`Error al descargar desde Blocktrace: ${response.status}`);
          }

          // Crear el Blob y descargar
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = doc.name || "documento.pdf";
          document.body.appendChild(a);
          a.click();
          a.remove();

          window.URL.revokeObjectURL(url);
          console.log("DEBUG - Descarga completada");
        } catch (error) {
          console.error("DEBUG - Error en descarga desde Cloud Function:", error);
          alert("Error al descargar el documento desde Blocktrace");
        }
      }

    } catch (error) {
      console.error("Error en la descarga:", error);
      alert("No se pudo descargar el archivo");
    }
  };


  const deleteDocument = async (document) => {

    const folder = await getDoc(doc(db, 'private-hubs', hubId, 'Carpetas', document.folderId));

    if (!tienePermisosEscritura(folder.data())) {
      alert("Permisos insuficientes para borrar este documento");
      return;
    }
    if (!window.confirm('¿Quieres eliminar este documento?')) return;

    try {
      if(!hubInfo.useBlocktrace){
        // Extraer ruta de Storage desde la URL
        const baseUrl = 'https://firebasestorage.googleapis.com/v0/b/lyseis-tools-hub.firebasestorage.app/o/';
        const pathEncoded = document.url.replace(baseUrl, '').split('?')[0]; // parte codificada
        const path = decodeURIComponent(pathEncoded);

        // Ref al archivo en Storage
        const fileRef = ref(storage, path);

        // Borrar archivo en Storage
        await deleteObject(fileRef);

        // Borrar documento en Firestore
        await deleteDoc(doc(db, 'private-hubs', hubId, 'Documentos', document.id));

        alert('Documento eliminado');

      }
      else{
        alert("Eliminación de documentos en Blocktrace no permitida");
      }
    } catch (error) {
      console.error('Error eliminando documento:', error);
      alert('Error al eliminar documento');
    }
  };

  const tienePermisosEscritura = (currentParentFolder) => {
    const permisosGenerales = permisos.verDocs;
    const permisosCarpeta = currentParentFolder.permisosUsuarios?.[userData.uid] || '';

    if(permisosCarpeta === 'lectura_escritura'){
      return true;
    }
    if(permisosGenerales === 'lectura_escritura' && (permisosCarpeta !== 'lectura')) {
      return true;
    }
    return false;
  }

  return (
    <div className="document-list">
      <h3>Documentos</h3>
      {documents.length === 0 ? (
        <p className="text-gray-600">No hay documentos en esta carpeta.</p>
      ) : (
        <ul>
          {documents.map((doc) => (
            <li key={doc.id}>
              <button
                onClick={() => downloadFile(doc)}
                className="btn-download"
              >
                📄 {doc.name}
              </button>
              <button
                onClick={() => deleteDocument(doc)}
                className="btn-delete"
                style={{ marginLeft: '10px', color: 'red' }}
              >
                🗑️ Eliminar
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DocumentList;
